/*** IMPORTS FROM imports-loader ***/
(function() {

define([], function () {

  var standard_footwear = {
    "title": "Home Depot Size Guide",
    "charts": [{
      "title": "Men's",
      "selected": true,
      "headings": ["US", "UK", "EURO", "Heel-to-Toe (cm.)"],
      "rows":[["6","5","40","23.5"],["6.5","5.5","40","24.1"],["7","6","41","24.7"],["7.5","6.5","41","25.3"],["8","7","42","25.9"],["8.5","7.5","42","26.5"],["9","8","43","27.1"],["9.5","8.5","43","27.7"],["10","9","44","28.3"],["10.5","9.5","44","28.9"],["11","10","45","29.5"],["11.5","10.5","45","30.1"],["12","11","46","30.7"],["12.5","11.5","46","31.3"],["13","12","47","31.9"],["13.5","12.5","47","32.5"],["14","13","48","33.1"],["14.5","13.5","48","33.7"],["15","14","49","34.3"]]
    },{
      "title": "Men's to Women's",
      "headings": ["Men's", "Women's"],
      "rows":[["4","6"],["4.5","6.5"],["5","7"],["5.5","7.5"],["6","8"],["6.5","8.5"],["7","9"],["7.5","9.5"],["8","10"],["8.5","10.5"],["9","11"],["9.5","11.5"],["10","12"],["10.5","12.5"],["11","13"],["11.5","13.5"],["12","14"],["12.5","14.5"],["13","15"]]
    },{
      "title": "Men's-to-Women's Width",
      "headings": ["Width", "Men's", "Women's"],
      "rows": [["A","","Narrow"],["B, N","Narrow","Regular/Standard"],["D, C, M","Regular/Standard","Wide"],["W, E","Wide","Extra Wide"],["2E, EE, WW, XW","Extra Wide","Extra Extra Wide"],["3E, EEE, WWW, XXX","Extra Extra Wide",""]]
    }]
  };

  var standard = {
    "title": "Home Depot Size Guide",
    "charts": [{
      "title": "Men",
      "selected": true,
      "headings": ["Size", "Chest (inches)", "Waist (inches)"],
      "rows": [
        ["Extra Small","33-34","27-28"],
        ["Small","35-37","29-31"],
        ["Medium","38-40","32-34"],
        ["Large","42-44","36-38"],
        ["Extra Large","46-48","40-42"],
        ["2X Large","50-52","44-46"],
        ["3X Large","54-56","48-50"],
        ["4X Large","58-60","52-54"],
        ["5X Large","62-64","56-58"],
        ["6X Large","66-68","60-62"]
      ]
      },{
        "title": "Women",
        "headings": ["Size", "Size U.S.", "Bust/Chest (inches)", "Waist (inches)"],
        "rows":[["Extra Small","0-2","31.5-32.5","23-24"],["Small","4-6","33.5-34.5","25-26"],["Medium","8-10","35.5-37.5","27-28"],["Large","12-14","38.5-40","29.5-31"],["Extra Large","16-18","41.5-43.5","35.5-38"],["Extra Large","20","45.5","40.5"]]
      }
    ]

  };

  var carhartt = {
    "title": "Carhartt Size Guide",
    "charts": [{
      "title": "Men",
      "selected": true,
      "headings": ["Size", "Chest (inches)", "Waist (inches)"],
      "rows":[["Small","34-38","28-30"],["Medium","38-40","32-34"],["Large","42-44","36-38"],["Extra Large","46-48","40-42"],["2X Large","50-52","44-46"],["3X Large","54-56","48-50"],["4X Large","58-60","52-54"],["5X Large","62-64","56-58"],["6X Large","66-68","60-62"]]
      },{
        "title": "Women",
        "headings": ["Size", "Size U.S.", "Bust/Chest (inches)", "Waist (inches)"],
        "rows": [["Extra Small","2","33","27"],["Small","4-6","34-35","28-29"],["Medium","8-10","36-37","30-32"],["Large","12-14","38.5-40","32.5-34"],["Extra Large","16-18","41.5-43","31-33"],["2X Large","20-22","44-46","35-37"]]
      }
    ]

  };

  return {
    footwear: {
      standard: standard_footwear
    },
    clothing: {
      standard: standard,
      carhartt: carhartt
    }
  }

});

}.call(window));